import React from 'react';

import AllocationAndBooking from './AllocationAndBooking';

type Area = {
  name?: string;
};

type Designation = {
  name?: string;
  area?: Area;
};

type AllocationCardProps = {
  userId: number | string;
  designation?: Designation;
};

export default function AllocationCard({ userId, designation }: AllocationCardProps) {
  return (
    <div className="full-scope-card dashboard__card allocation-card d-flex flex-direction-column">
      <AllocationAndBooking userId={userId} designation={designation} />
    </div>
  );
}
